export const COMPANY_REQUEST = 'COMPANY_REQUEST'
export const COMPANY_SUCCESS = 'COMPANY_SUCCESS'
export const COMPANY_FAILURE = 'COMPANY_FAILURE'

export const APPEARANCE_REQUEST = 'APPEARANCE_REQUEST'
export const APPEARANCE_SUCCESS = 'APPEARANCE_SUCCESS'
export const APPEARANCE_FAILURE = 'APPEARANCE_FAILURE'